import Pay from "./Pay";

export default Pay;
